import { useEffect } from "react";

import { makeApiCall } from "@lib/api/helpers";
import { getCmsBlocksApi } from "@lib/api";

const RCASidebarNew = ({ cmsBlockData, onApiDataUpdate }) => {
  useEffect(() => {
    const fetchCmsBlockData = async () => {
      const response = await makeApiCall({
        apiCall: getCmsBlocksApi,
        formatResponse: (response) => response.data,
        apiArgs: [["faq_asigurare-rca", "info_rca"]],
      });

      if (response.blocks?.length) {
        onApiDataUpdate({ cmsBlockData: response.blocks });
      }
    };

    if (!cmsBlockData?.length) {
      fetchCmsBlockData();
    }
  }, []);

  if (!cmsBlockData?.length) {
    return null;
  }

  return (
    <div className="space-y-[20px]">
      {cmsBlockData &&
        cmsBlockData.map((block, index) => (
          <div
            key={`${block.identifier}-${index}`}
            className="Cms"
            dangerouslySetInnerHTML={{ __html: block.content }}
          />
        ))}
    </div>
  );
};

export default RCASidebarNew;
